import '@mdi/font/css/materialdesignicons.css'

import 'vuetify/styles'
// import '../assets/main.scss'

import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
// import { md1 } from 'vuetify/blueprints'

const kardeLightTheme = {
  dark: false,
  colors: {
    background: '#F2F0EE', //'#fafafacc',
    surface: '#F2F0EE', //'#fafafccc',
    primary: '#6200EE',
    'primary-darken-1': '#3700B3',
    secondary: '#00695C',
    'secondary-darken-1': '#004D40',
    error: '#B00020',
    info: '#0D47A1',
    success: '#1B5E20',
    warning: '#8A3A00'
  },
  variables: {
    'medium-emphasis-opacity': 0.8,
    'disabled-opacity': 0.6
  }
}

const vuetify = createVuetify({
  components,
  directives,
  ssr: true,
  theme: {
    defaultTheme: 'kardeLightTheme',
    themes: {
      kardeLightTheme
    }
  }
})

export default vuetify
